// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"354":"project","462":"legal"}[chunkId] || chunkId) + "." + {"354":"083a40e0","462":"35feab5f","592":"f6315e30","878":"4c0ecdee"}[chunkId] + ".css";
};